import PriceDisplayElem, { PriceI } from "./PriceDisplayElem.tsx";
import CardPlanButton from "./CardPlanButton.tsx";
import useMediaQueries from "hooks/useMediaQueries";
import useStickyDetection from "../Utils/useStickyDetection.ts";
import BlackFridayPromoElem from "components/Reusable/BlackFriday/BlackFridayPromoElem.js";
import { LinkToNewTab } from "components/Elements/Link/Link";
import { useContent } from "contexts/contentContext/contentContext";
import { Fragment } from "react";

interface PricesI {
  [key: string]: PriceI;
}

interface CouponI {
  [key: string]: string | number;
}

interface HeaderFeaturesListI {
  type: string;
  clickedCard: string;
  isYearly: boolean;
  alwaysSticky: boolean;
  prices: PricesI;
  coupons?: {
    [key: string]: CouponI;
  };
}

interface HeaderFeatureElemI {
  sysName: string;
  isYearly: boolean;
  isSticky: boolean | undefined;
  prices: PricesI;
  coupon?: CouponI;
}

enum FeturesLink {
  JUMBOforms = "jumbo-forms",
  JUMBOpay = "jumbo-pay",
}

const HeaderFeatureElem = ({
  sysName,
  isYearly,
  prices,
  isSticky,
  coupon = {},
}: HeaderFeatureElemI) => {
  const { largeDesktopCondition } = useMediaQueries();

  return (
    <div
      className={`${sysName} col ${largeDesktopCondition ? "row" : ""} ${
        !isSticky ? " hidden" : ""
      }`}
    >
      <div className="top-section">
        <PriceDisplayElem
          isYearly={isYearly}
          prices={prices[sysName]}
          tablePrice
          discount={+coupon?.PrecentSale}
        />
      </div>
      <CardPlanButton
        isYearly={isYearly}
        sysName={sysName}
        couponCode={coupon?.CouponCode}
        tableButton
      />
      {isYearly && coupon?.PrecentSale ? (
        <BlackFridayPromoElem withHover number={coupon?.PrecentSale} />
      ) : null}
    </div>
  );
};

const HeaderFeaturesList = ({
  type,
  clickedCard,
  isYearly,
  prices,
  alwaysSticky,
  coupons = {},
}: HeaderFeaturesListI) => {
  // if JUMBOforms put id of jumbo-forms-id
  // if JUMBOpicker put id of jumbo-picker-id

  const { getTextByKey, getBlackFridayTime, getBlackFridayTimeCookie } =
    useContent();
  const { mobileCondition } = useMediaQueries();

  const { isSticky, targetRef } = useStickyDetection();

  const displayColum = (type: string) => {
    if (["JUMBOforms", "JUMBOpay"].includes(type)) {
      return (
        <>
          {getTextByKey(type)}
          <LinkToNewTab
            classes={"jumbo-feature-link"}
            isNewTab
            page={FeturesLink[type]}
          >
            ({`${getTextByKey("learn-more")}`})
          </LinkToNewTab>
        </>
      );
    } else {
      return getTextByKey(type);
    }
  };

  const getId = () => {
    if (["JUMBOforms", "JUMBOpay"].includes(type)) {
      return "with-active-link";
    } else {
      return "";
    }
  };

  const promoCondition = getBlackFridayTime() && isYearly;

  return (
    <div
      className={`header-feature-list${
        promoCondition ? " page-with-promo" : ""
      }${!getBlackFridayTimeCookie() ? " default-sticky" : ""}`}
      ref={targetRef}
    >
      <div className="category col" id={getId()}>
        {displayColum(type)}
      </div>
      {mobileCondition ? (
        <HeaderFeatureElem
          sysName={clickedCard}
          isYearly={isYearly}
          prices={prices}
          isSticky={alwaysSticky || isSticky}
          coupon={coupons[clickedCard]}
        />
      ) : (
        <>
          {Object.keys(prices).map((sysName, i) =>
            sysName !== "enterprise" ? (
              <Fragment key={sysName}>
                {i === 0 ? (
                  <HeaderFeatureElem
                    sysName={"free"}
                    isYearly={isYearly}
                    prices={prices}
                    isSticky={alwaysSticky || isSticky}
                  />
                ) : null}
                <HeaderFeatureElem
                  sysName={sysName}
                  isYearly={isYearly}
                  prices={prices}
                  isSticky={alwaysSticky || isSticky}
                  coupon={coupons[sysName]}
                />
              </Fragment>
            ) : null
          )}
        </>
      )}
    </div>
  );
};

export default HeaderFeaturesList;
